import { render, staticRenderFns } from "./car-mileage.vue?vue&type=template&id=51268b08&"
import script from "./car-mileage.vue?vue&type=script&lang=js&"
export * from "./car-mileage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51268b08')) {
      api.createRecord('51268b08', component.options)
    } else {
      api.reload('51268b08', component.options)
    }
    module.hot.accept("./car-mileage.vue?vue&type=template&id=51268b08&", function () {
      api.rerender('51268b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/car-mileage.vue"
export default component.exports